import axios from "axios";
import { useEffect, useState, useContext } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import MyContext from "../../../context/MyContext";
import "../../../assets/css/delivery/auth/DeliveryAuth.css";

const DeliveryLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const {
    baseUrl,
    setAuthToken,
    setLoggedInDeliveryMan
  } = useContext(MyContext);
  const navigate = useNavigate();

  // ── Auto Login ──
  const autoLogin = (savedPhone, savedPassword) => {
    setLoading(true);
    const formdata = new FormData();
    formdata.append("phone", savedPhone);
    formdata.append("password", savedPassword);

    axios
      .post(`${baseUrl}/delivery/auth/login`, formdata)
      .then((response) => {
        if (!response.data.token) {
          setLoading(false);
          localStorage.removeItem("deliveryPhone");
          localStorage.removeItem("deliveryPassword");
        } else {
          setLoading(false);
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token);
          localStorage.setItem(
            "loggedInDeliveryMan",
            JSON.stringify(response.data.deliveryman),
          );
          setLoggedInDeliveryMan(response.data.deliveryman);
          // ── FIXED: hamesha /delivery/my-jobs pe navigate ho raha tha,
          // chahe KYC ho ya na ho. Ab agar KYC approved nahi hai to
          // seedha Settings ke KYC tab pe le jate hain, warna Open Jobs pe ──
          if ((response.data.deliveryman?.is_verified || "").toLowerCase() !== "approved") {
            navigate("/delivery/settings", { state: { openTab: "kyc" } });
          } else {
            navigate("/delivery/open-jobs");
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        localStorage.removeItem("deliveryPhone");
        localStorage.removeItem("deliveryPassword");
      });
  };

  // ── Login ──
  const loginDelivery = () => {
    setLoading(true);
    setErrorMessage("");
    const formdata = new FormData();
    formdata.append("phone", phone);
    formdata.append("password", password);

    axios
      .post(`${baseUrl}/delivery/auth/login`, formdata)
      .then((response) => {
        if (!response.data.token) {
          setErrorMessage("Invalid phone number or password");
          setLoading(false);
        } else {
          setLoading(false);
          localStorage.setItem("deliveryPhone", phone);
          localStorage.setItem("deliveryPassword", password);
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token);
          localStorage.setItem(
            "loggedInDeliveryMan",
            JSON.stringify(response.data.deliveryman),
          );
          setLoggedInDeliveryMan(response.data.deliveryman);
          // ── FIXED: hamesha /delivery/my-jobs pe navigate ho raha tha,
          // chahe KYC ho ya na ho. Ab agar KYC approved nahi hai to
          // seedha Settings ke KYC tab pe le jate hain, warna Open Jobs pe ──
          if ((response.data.deliveryman?.is_verified || "").toLowerCase() !== "approved") {
            navigate("/delivery/settings", { state: { openTab: "kyc" } });
          } else {
            navigate("/delivery/open-jobs");
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage("Login failed. Please check your credentials.");
        setLoading(false);
      });
  };

  // ── Auto Login on mount ──
  useEffect(() => {
    const savedPhone = localStorage.getItem("deliveryPhone");
    const savedPassword = localStorage.getItem("deliveryPassword");
    if (savedPhone != null && savedPhone !== "") {
      autoLogin(savedPhone, savedPassword);
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <div className="delivery-auth-wrapper">
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255,255,255,0.9)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner
            animation="border"
            role="status"
            style={{ width: "4rem", height: "4rem" }}
          />
          <p style={{ marginTop: "15px", fontSize: "18px" }}>
            Logging you in...
          </p>
        </div>
      ) : (
        <>
          <div className="delivery-doodle-background">
            <div className="delivery-doodle-pattern"></div>
          </div>
          <div className="delivery-auth-container">
            <div className="delivery-auth-card">
              <div className="delivery-auth-logo">
                <div className="delivery-logo-icon">🚜</div>
              </div>
              <div className="delivery-auth-header">
                <h1 className="delivery-auth-title">Delivery Login</h1>
                <p className="delivery-auth-subtitle">
                  Don't have an account?{" "}
                  <Link to="/delivery/register" className="delivery-auth-link">
                    Register here
                  </Link>
                </p>
              </div>
              <Form className="delivery-minimal-form">
                <div className="delivery-form-group">
                  <Form.Control
                    type="tel"
                    placeholder="Phone number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className="delivery-minimal-input"
                  />
                </div>
                <div className="delivery-form-group">
                  <div className="delivery-password-wrapper">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="delivery-minimal-input"
                    />
                    <button
                      type="button"
                      className="delivery-password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>
                <div className="text-end mb-2">
                  <Link
                    to="/delivery/forgot-password"
                    className="delivery-forgot-link"
                  >
                    Forgot password?
                  </Link>
                </div>
                {errorMessage && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "0.875rem",
                      marginBottom: "1rem",
                      padding: "0.75rem",
                      background: "#fff3f3",
                      borderRadius: "8px",
                      border: "1px solid #ffdddd",
                    }}
                  >
                    {errorMessage}
                  </div>
                )}
                <Button
                  type="button"
                  className="delivery-submit-btn"
                  onClick={() => loginDelivery()}
                  disabled={loading}
                >
                  Log In
                </Button>
              </Form>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DeliveryLogin;
